import { useEffect, useRef, useState } from "react";
import { useIsFetching, useIsMutating } from "@tanstack/react-query";

const MIN_VISIBLE_MS = 250;
const LINGER_MS      = 140;

export default function LoadingBar() {
  const fetching = useIsFetching();
  const mutating = useIsMutating();
  const pending = fetching + mutating;
  const [active, setActive] = useState(false);
  const shownAt = useRef<number | null>(null);

  useEffect(() => {
    if (pending > 0) {
      if (!active) {
        setActive(true);
        shownAt.current = Date.now();
      }
      return;
    }
    const sinceShown = shownAt.current ? Date.now() - shownAt.current : MIN_VISIBLE_MS;
    const wait = Math.max(LINGER_MS, MIN_VISIBLE_MS - sinceShown);
    const t = window.setTimeout(() => {
      setActive(false);
      shownAt.current = null;
    }, wait);
    return () => window.clearTimeout(t);
  }, [pending, active]);

  return (
    <div className="loading-bar" aria-hidden={!active} data-active={active}>
      <span className="bar-1" />
      <span className="bar-2" />
    </div>
  );
}
